<div class="center-container">
  <div *ngIf="currentBrowserClient.name === 'Chrome'">
      <div class="center-div" *ngIf="showWarningMessage(currentBrowserClient.name, currentBrowserClient.version, currentBrowserClient.release);">
        <div class="close-div"><img (click)="redirectRoot()" class="img-close" src="assets\img\close.png"></div>
        {{ 'browseWarningChrome.TITLE' | translate }} <strong>{{ 'browseWarningChrome.STRONG' | translate }}</strong>
      </div>
  </div>
  <div *ngIf="currentBrowserClient.name === 'Edge'">
      <div class="center-div">
        <div class="close-div"><img (click)="redirectRoot()" class="img-close" src="assets\img\close.png"></div>
        {{ 'browseWarningEdge.TITLE' | translate }} <strong>{{ 'browseWarningEdge.STRONG' | translate }}</strong>
      </div>
  </div>
  <div *ngIf="currentBrowserClient.name === 'Firefox'">
      <div class="center-div" *ngIf="showWarningMessage(currentBrowserClient.name, currentBrowserClient.version, currentBrowserClient.release);">
        <div class="close-div"><img (click)="redirectRoot()" class="img-close" src="assets\img\close.png"></div>
        {{ 'browseWarningFirefox.TITLE' | translate }} <strong>{{ 'browseWarningFirefox.STRONG' | translate }}</strong>
      </div>
  </div>
  <div *ngIf="currentBrowserClient.name === 'IE'">
      <div class="center-div">
        <div class="close-div"><img  (click)="redirectRoot()" class="img-close" src="assets\img\close.png"></div>
        {{ 'browseWarningIE.TITLE' | translate }} <strong>{{ 'browseWarningIE.STRONG' | translate }}</strong>
      </div>
  </div>
  <div *ngIf="currentBrowserClient.name === 'Safari'">
      <div class="center-div" *ngIf="showWarningMessage(currentBrowserClient.name, currentBrowserClient.version, currentBrowserClient.release);">
          <div class="close-div"><img (click)="redirectRoot()" class="img-close" src="assets\img\close.png"></div>
          {{ 'browseWarningSafari.TITLE' | translate }} <strong>{{ 'browseWarningSafari.STRONG' | translate }}</strong>
        </div>
  </div>
</div>
